import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import qs from 'qs'
import oikosApi from '../services/oikos'

export function sectorIdsOf(pfSetoresId) {
  if (Array.isArray(pfSetoresId)) return pfSetoresId.map((id) => String(id))
  if (pfSetoresId == null || pfSetoresId === '') return []
  if (typeof pfSetoresId === 'number') return [String(pfSetoresId)]
  const text = String(pfSetoresId).trim()
  if (!text) return []
  try {
    const parsed = JSON.parse(text)
    if (Array.isArray(parsed)) return parsed.map((id) => String(id))
  } catch (err) {
    // lista gravada fora de JSON
  }
  return text.split(',').map((id) => id.replace(/[^0-9]/g, '')).filter(Boolean)
}

let financeSectorIdPromise = null

export function loadFinanceSectorId() {
  if (!financeSectorIdPromise) {
    financeSectorIdPromise = oikosApi
      .get(`/?${qs.stringify({
        action: 'get',
        table: 'setor',
        data: { setor_nome: 'Financeiro' },
      })}`)
      .then((res) => {
        const rows = Array.isArray(res?.data) ? res.data : []
        const row = rows.find((item) => String(item?.setor_nome || '').trim() === 'Financeiro')
        return row?.setor_id == null ? null : String(row.setor_id)
      })
      .catch((err) => {
        financeSectorIdPromise = null
        throw err
      })
  }
  return financeSectorIdPromise
}

export async function isFinanceSectorUser(user) {
  const ids = sectorIdsOf(user?.pf_setoresId)
  if (!ids.length) return false
  const setorId = await loadFinanceSectorId()
  if (!setorId) return false
  return ids.includes(setorId)
}

export function useFinanceSectorUser() {
  const user = useSelector((state) => state.auth?.user)
  const setores = user?.pf_setoresId
  const pfId = user?.pf_id
  const [allowed, setAllowed] = useState(false)

  useEffect(() => {
    let cancelled = false
    setAllowed(false)
    isFinanceSectorUser(user)
      .then((ok) => {
        if (!cancelled) setAllowed(!!ok)
      })
      .catch(() => {
        if (!cancelled) setAllowed(false)
      })
    return () => {
      cancelled = true
    }
  }, [pfId, setores, user])

  return allowed
}
